<template>
  <div>
    <b-row>
      <b-col>
        <div class="team-members-container">
          <div v-if="loading">
            <p>{{$t('general.loading')}}</p>
          </div>
          <b-list-group v-else>
            <b-list-group-item
              v-for="accountMember in accountMembers"
              :key="accountMember.id"
              class="d-flex justify-content-between align-items-center">
              <b-row>
                <b-col cols="12">
                  <span>{{accountMember.firstName}} {{accountMember.lastName}}</span>
                </b-col>
                <b-col cols="12">
                  <span class="text-black-50"><small>{{accountMember.email}}</small></span>
                </b-col>
                <b-col cols="12" v-if="user.role === 'Admin' && accountMember.id !== user.id">
                  <span
                    class="primary-text"
                    @click="removeUser(accountMember)"
                  ><small>{{$t('teamMembers.removeUser')}}</small></span>
                </b-col>
              </b-row>
              <b-badge pill :variant="getPillVariant(accountMember.role)">
                {{accountMember.role}}
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: mapState({
      user: state => state.account.user,
      accountMembers: state => state.account.accountMembers,
    }),
    data() {
      return {
        loading: true,
      };
    },
    mounted() {
      this.getAccountMembers();
    },
    methods: {
      getAccountMembers() {
        this.$store.dispatch('account/getAccountMembers')
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.$toasted.error(this.$t('teamMembers.errorFetchingTeamMembers'));
          });
      },
      getPillVariant(role) {
        switch (role) {
          case 'Admin':
            return 'primary';
          case 'Member':
            return 'secondary';
          case 'Guest':
            return 'warning';
          default:
            return 'warning';
        }
      },
      removeUser(userToRemove) {
        this.$swal({
          title: this.$t('teamMembers.removeUserModalTitle'),
          text: this.$t('teamMembers.removeUserModalText', {
            name: userToRemove.firstName,
            appName: this.$t('appName'),
          }),
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        })
          .then((willDelete) => {
            if (!willDelete) {
              return;
            }
            this.$store.dispatch('account/removeUser', { userId: userToRemove.id })
              .then(() => {
                this.$toasted.success(this.$t('teamMembers.successfullyRemovedUser', { name: userToRemove.firstName }));
              })
              .catch((err) => {
                let errorMessage = this.$t('teamMembers.errorRemovingUser', { name: userToRemove.firstName });
                if (err.response.status >= 400 && err.response.status < 500) {
                  errorMessage = err.response.data.message;
                }
                this.$toasted.error(errorMessage);
              });
          });
      },
    },
  };
</script>

<style scoped>
  .team-members-container {
    min-height: 200px;
  }
</style>
